// extracted by mini-css-extract-plugin
module.exports = {"ohlcPriceRoot":"nmnriyyg","priceContainer":"R1jusE1q","label":"qwmIUYia","price":"izqMqCcd","bullish":"ps8agYTt"};